import TextWinds from '../../../common/TextWinds';
import Banner from './Banner';
import { LmsInfoTypes } from '../../../../constants/types';

interface NoticeProps {
  lmsLists: LmsInfoTypes;
}

/**
 * 개편 LMS (교사) - 클램스 홈 페이지 > 모바일 안내 & 배너
 */
const Notice = ({ lmsLists }: NoticeProps) => {
  return (
    <>
      {/* 모바일 버전 안내 문구 */}
      <div className="rounded bg-purple0 px-3 py-[14px] xl:hidden">
        <TextWinds type="caption1" color="purple4">
          본 LMS는 PC에서 이용을 권장합니다. 다양한 LMS 기능들을 모바일 버전보다
          훨씬 편리하게 이용할 수 있어요.
        </TextWinds>
      </div>

      <section className="m-auto w-full max-w-[1920px] xl:max-h-[150px]">
        <Banner lmsLists={lmsLists} />
      </section>
    </>
  );
};

export default Notice;
